<template lang="pug">
  button.btn-follow(:class="css" @click="update()")
    span(v-if="!active") Seguir
    span(v-if="active") Dejar de seguir
</template>

<script>
export default {
  name: 'b-follow',
  props: {
    data: Number,
    type: String, 
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    css() {
      let result = {
        'active': this.active,
      }

      result[`btn-follow-${this.$props.type}`] = true

      return result
    },
  },
  methods: {
    update() {
      let row = {}
      let data = {}
      row[`${this.$props.type}_id`] = this.$props.data
      if (this.active) row['_destroy'] = 1
      data[`${this.$props.type}_follows_attributes`] = [row]

      $.ajax({
        url : '/seguidos',
        data : JSON.stringify({
          user: data,
        }),
        type : 'PATCH',
        contentType : 'application/json',
        success: res => this.check()
      })
    },
    check() {
      $.ajax({
        url : `/seguidos/status?${this.$props.type}_id=${this.$props.data}`,
        type : 'get',
        contentType : 'application/json',
        success: res => { 
          this.active = res && res.exists
        }
      }); 
    }
  },
  mounted() {
    this.check()
  }
};
</script>


// WEBPACK FOOTER //
// follow.vue